import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Form from '../../../gd-form/form/form-modal-new/form-modal-new';
import FormManager from '../../../gd-form/common/form-manager';
import VScroll from "../../../gd-components/scrolling/custom-v-scroll/v-scroll";

import Classes from 'classnames';

class ModalProjectViewSaveAs extends Component {

    static propTypes = {
        projectId: PropTypes.string,
        viewId: PropTypes.number,
        onSubmit: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        const initFormData = {
            selectedId: gd.projectViews.currentView.id,
        };

        const formStructure = {
            isFormChanged: true,
            fields: {
                selectedId: {
                    type: 'select'
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onClickOption = (value) => {
        this.form.setFieldValue("selectedId", value);
        this.forceUpdate();
    };

    onSubmit = (result) => {
        // result.id = gd.utils.guid();
        this.props.onSubmit(result);
    };

    render() {
        // const options = ViewsPresetsManager.getViewPresetsOptions(this.props.projectId, this.props.viewId);
        const selectedId = this.form.getValue("selectedId");

        return (
            <Form form={this.form} submitLabel="Save">
                <VScroll containerClass="available-view-presets-scroll" minDragHeight={10}>
                    <div className="available-view-presets">
                        {gd.projectViews.getSaveAsOptions().map(view => {
                            const classes = Classes("view-preset-option", {"is-selected": view.id === selectedId});

                            return (
                                <div key={view.id} className={classes} onClick={this.onClickOption.bind(this,view.id)}>
                                    <div className="option-selection-icon"/>
                                    <div className="option-label">{view.name}</div>
                                </div>
                            );
                        })}
                    </div>
                </VScroll>
            </Form>
        );
    }
}

module.exports = ModalProjectViewSaveAs;